module.exports = __webpack_public_path__ + "static/media/004.24026303.jpg";